import { GenericServiceRequest } from './generic-service-request';
import { AutoCompleteModelOptions } from '../domain-models/autocomplete/auto-complete-options';

export class AutoCompleteModelRequest extends GenericServiceRequest<AutoCompleteModelOptions> {

}
